import { Dayjs } from "dayjs"
import { IWarrantsDcaQueue } from "@/models/admin/warrantsDcaQueue/warrantsDcaQueue.types"

export class WarrantsDcaQueue implements IWarrantsDcaQueue {
  constructor(
    public id: number,
    public accountNumber: string,
    public createdAt: Dayjs,
    public processedAt: Dayjs | null,
    public deletedAt: Dayjs | null,
  ) {}

  get isProcessed(): boolean {
    return this.processedAt !== null
  }

  get isDeleted(): boolean {
    return this.deletedAt !== null
  }
}
